import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apiAuthLogoutPost, notifyAuthChanged } from '@/entities/auth';
import { clearTokens, getRefreshToken } from '@/shared/lib/auth';
import { showToast } from '@/shared/hooks/useToast';

export const useStaffLogout = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const logout = useCallback(async () => {
    setIsLoading(true);
    const refresh = getRefreshToken();
    try {
      if (refresh) await apiAuthLogoutPost({ refresh_token: refresh });
    } catch {
      // ignore
    } finally {
      clearTokens();
      notifyAuthChanged();
      setIsLoading(false);
      showToast({ kind: 'info', message: t('topbar.toast.signedOut') });
      navigate('/login', { replace: true });
    }
  }, [navigate, t]);

  return { logout, isLoading };
};
